export function Spinner({ label }: { label?: string }) {
  return <div className="muted">{label ?? 'Loading…'}</div>;
}
